<template>
  <div>
    <slot :openReportInspectorDialog="openReportInspectorDialog">
      <el-button type="primary"
                 size="default"
                 class="inspect-btn"
                 :disabled="btnDisabled"
                 @click="openReportInspectorDialog">
        <img v-if="!btnDisabled"
             class="inspect-btn__icon"
             src="/statics/view-module-alt.png">
        <i v-else class="el-icon-loading" />
        {{ $t('Inspect Report') }}
      </el-button>
    </slot>

    <ReportInspectorDialog :visible="dialogVisibility"
                           :report-data="reportData"
                           :project-id="projectId"
                           :mosaic-image="getMosaicOriginalImage"
                           :image-sets="imageSets"
                           :before-close-dialog="beforeCloseReportInspectorDialog"
                           :report-data-images="getReportDataImages"
                           :image-results="getImageResults"
                           :report="getReport"
                           :skus="filteredProjectSkus"
                           :reference-image-set="refImageSets"
                           :reference-image-set-report="referenceImageSet"
                           :reference-image-results="getReferenceImageResults"
                           :competitor-sku-list="CompetitorSkuList.data"
                           :non-sku-list="NonSkuList.data" />
  </div>
</template>

<script>
import { result } from 'lodash';
import { createCrudState } from 'vuex-module-generator';
import { fetchVisitSkuValidations, fetchNonSkuClasses } from '@/modules/sku-validation/api';
import { fetchSkus } from '@/shared/apis';
import { fetchImageset } from '@/modules/imageset/api';
import { Message } from 'element-ui';
import ReportInspectorDialog from './components/ReportInspectorDialog';
import errorResolver from '../../helpers/errorResolver';
import bus from './report-inspector-scene/bus';
import InspectorBus from './InspectorBus';
import { getSceneData } from './utils';

export default {
  name: 'ReportInspector',
  components: {
    ReportInspectorDialog
  },
  props: {
    reportData: {
      type: Object,
      required: true
    },
    projectId: {
      type: [String, Number],
      required: true
    },
    visitId: {
      type: [String, Number],
      required: true
    },
    skusData: {
      type: Array,
      default() {
        return [];
      }
    },
    btnDisabled: {
      type: Boolean,
      default: true
    },
    isScrollDown: {
      type: Boolean,
      default: false
    },
    scrollTopDistance: {
      type: Number,
      default: 0
    },
    reportSkusIdList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      bus,
      dialogVisibility: false,
      loading: false,
      error: false,
      scene_data: {
        image_sets: [],
        normal_sku_count: 0,
        non_sku_count: 0,
        unrecognized_sku_count: 0,
        meta_sku_count: 0,
        visit: {}
      },
      reference_scene_data: {
        image_sets: [],
        normal_sku_count: 0,
        non_sku_count: 0,
        unrecognized_sku_count: 0,
        meta_sku_count: 0,
        visit: {}
      },
      MetaSkuList: createCrudState().list,
      CompetitorSkuList: createCrudState().list,
      NonSkuList: createCrudState().list,
      crops: {},
      referenceImageSet: {},
      windowWidth: null
    };
  },
  computed: {
    // TODO: refactor this
    getMosaicOriginalImage() {
      return result(this.reportData, 'mosaic.original');
    },
    imageSets() {
      return this.scene_data.image_sets;
    },
    getReportDataImages() {
      return this.reportData.images;
    },
    getImageResults() {
      return this.reportData.report ? this.reportData.report.image_results : [];
    },
    getReport() {
      return this.reportData.report;
    },
    refImageSets() {
      return this.reference_scene_data.image_sets;
    },
    getReferenceImageResults() {
      return this.referenceImageSet.report ? this.referenceImageSet.report.image_results : [];
    },
    reportDataSkuList() {
      if (this.reportData.report && this.reportData.report.sku_list) {
        return this.reportData.report.sku_list;
      }

      return [];
    },
    filteredProjectSkus() {
      bus.skuListForPixiLoader = this.skusData.filter(element => this.reportDataSkuList.find(({ sku }) => element.id === sku.id));

      return this.skusData.filter(element => this.reportDataSkuList.find(({ sku }) => element.id === sku.id));
    }
  },
  async mounted() {
    this.windowWidth = window.innerWidth;
    // await this.fetchMetaSkus();

    try {
      await this.fetchCompetitorSkus();
    } catch (error) {
      const { message } = errorResolver(error);
      Message({
        type: 'error',
        title: 'Error',
        message
      });
    }

    try {
      await this.fetchNonSkus();
    } catch (error) {
      const { message } = errorResolver(error);
      Message({
        type: 'error',
        title: 'Error',
        message
      });
    }

    try {
      await this.fetchValidation();
    } catch (error) {
      const { message } = errorResolver(error);
      Message({
        type: 'error',
        title: 'Error',
        message
      });
    }

    try {
      if (this.reportData.reference_image_set_id && this.reportData.reference_image_sets_visit_id) {
        const { data: { data } } = await fetchImageset(this.projectId, this.reportData.reference_image_set_id);

        this.referenceImageSet = data;
        this.$emit('reference-imageset', data);

        await this.fetchReferenceValidation();
      }

      await this.populateSceneData();
    } catch (error) {
      this.error = errorResolver(error).message;
    }
  },
  methods: {
    async openReportInspectorDialog() {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth;
        this.handlePositionOfInspectorDialog();
      });

      this.loading = true;
      this.dialogVisibility = true;

      setTimeout(() => {
        this.handlePositionOfInspectorDialog();
      }, 100);

      this.loading = false;
    },
    beforeCloseReportInspectorDialog() {
      this.dialogVisibility = false;

      window.removeEventListener('resize', () => {
        this.windowWidth = window.innerWidth;
        this.handlePositionOfInspectorDialog();
      });

      this.handlePositionOfInspectorDialog();
    },
    async fetchValidation() {
      bus.VisitSkuValidation.isLoading = true;

      return fetchVisitSkuValidations(this.projectId, this.visitId)
        .then(({ data: { data } }) => {
          bus.VisitSkuValidation.data = data;

          if (data.sku_validation) {
            bus.ValidatedCrops.data = data.sku_validation;
          }

          return Promise.resolve(data);
        })
        .catch((err) => {
          bus.VisitSkuValidation.hasError = true;

          return Promise.reject(err);
        })
        .finally(() => {
          bus.VisitSkuValidation.isLoading = false;
        });
    },
    async fetchReferenceValidation() {
      bus.referenceVisitSkuValidation.isLoading = true;

      return fetchVisitSkuValidations(this.projectId, this.reportData.reference_image_sets_visit_id)
        .then(({ data: { data } }) => {
          bus.referenceVisitSkuValidation.data = data;

          return Promise.resolve(data);
        })
        .catch((err) => {
          bus.referenceVisitSkuValidation.hasError = true;

          return Promise.reject(err);
        })
        .finally(() => {
          bus.referenceVisitSkuValidation.isLoading = false;
        });
    },
    async fetchMetaSkus() {
      this.MetaSkuList.isLoading = true;

      return fetchSkus(this.projectId, { search: { ids: this.reportSkusIdList.toString(), meta: true }, per: 5000 })
        .then(({ data: { data } }) => {
          this.MetaSkuList.data = data;

          return Promise.resolve(data);
        })
        .catch((err) => {
          this.MetaSkuList.hasError = true;

          return Promise.reject(err);
        })
        .finally(() => {
          this.MetaSkuList.isLoading = false;
        });
    },
    async fetchCompetitorSkus() {
      this.CompetitorSkuList.isLoading = true;

      if (this.reportSkusIdList && this.reportSkusIdList.length) {
        await fetchSkus(this.projectId, {
          search: { ids: this.reportSkusIdList.toString() }, sku_group_tag_name: 'competitor', per: 5000
        })
          .then(({ data: { data } }) => {
            this.CompetitorSkuList.data = data;

            return Promise.resolve(data);
          })
          .catch((err) => {
            this.CompetitorSkuList.hasError = true;

            return Promise.reject(err);
          })
          .finally(() => {
            this.CompetitorSkuList.isLoading = false;
          });
      }
    },
    async fetchNonSkus() {
      this.NonSkuList.isLoading = true;

      return fetchNonSkuClasses(this.projectId, {
        page: 1,
        per: 9999
      })
        .then(({ data: { data } }) => {
          this.NonSkuList.data = data;

          return Promise.resolve(data);
        })
        .catch((err) => {
          this.NonSkuList.hasError = true;

          return Promise.reject(err);
        })
        .finally(() => {
          this.NonSkuList.isLoading = false;
        });
    },
    populateSceneData() {
      this.scene_data = getSceneData(bus.VisitSkuValidation, this.MetaSkuList.data, this.CompetitorSkuList.data);

      if (this.reportData.reference_image_set_id && this.reportData.reference_image_sets_visit_id) {
        this.reference_scene_data = getSceneData(bus.referenceVisitSkuValidation, this.MetaSkuList.data, this.CompetitorSkuList.data);
      }
    },
    handlePositionOfInspectorDialog() {
      const vModalElements = document.getElementsByClassName('v-modal');
      const dialogWrapperElements = document.getElementsByClassName('el-dialog__wrapper');

      if (vModalElements.length > 0 && dialogWrapperElements.length > 0) {
        const vModal = vModalElements[0];
        const dialogWrapper = dialogWrapperElements[0];

        if (this.windowWidth > 1024 && !InspectorBus.isFullScreen) {
          if (this.isScrollDown) {
            vModal.style.marginTop = 0;
            vModal.style.marginLeft = '80px';

            dialogWrapper.style.top = 0;
            dialogWrapper.style.left = '80px';
          } else {
            vModal.style.marginTop = `${104 + this.scrollTopDistance}px`;
            vModal.style.marginLeft = '80px';

            dialogWrapper.style.top = `${104 + this.scrollTopDistance}px`;
            dialogWrapper.style.left = '80px';
          }
        } else if (this.windowWidth <= 1024 && !InspectorBus.isFullScreen) {
          vModal.style.marginTop = 0;
          vModal.style.marginLeft = 0;

          dialogWrapper.style.top = 0;
          dialogWrapper.style.left = 0;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.inspect-btn {
  display: block;
  width: 100%;
  max-width: 326px;
  margin-right: auto;
  margin-left: auto;
  text-transform: uppercase;

  span {
    display: flex;
    align-items: center;
    justify-content: center;

    .inspect-btn__icon {
      margin-right: 10px;
      font-size: 24px;
    }

    .el-icon-loading {
      margin-right: 10px;
      font-size: 16px;
    }
  }
}
</style>
